import type { StatisticModeOption } from './statisticRowTypes';

export const STATISTIC_MODE_OPTIONS: readonly StatisticModeOption[] = [
  { value: 'tasks', label: 'Задания' },
  { value: 'calls', label: 'Звонки' },
] as const;
